import React, { useEffect } from "react";
import TopMostPortal from "../../../../components/ui/utils/Portals";
import { getProcessedEstimatesStore } from "../../../../data/ProcessedEstimatesStore";
import { observer } from "mobx-react";
import LineEditingDialog from "./LineEditingDialog";
import EngineUtils from "../../../../shared/common/EngineUtils";
import { logDebug } from "../../../../shared/common/logger";

const EstimateTableFooter: React.FC<{ pageId: string; roomName?: string }> = observer(({ pageId, roomName }) => {
	const processedEstimatesStore = getProcessedEstimatesStore();
	const [mergedPageId, setMergedPageId] = React.useState<string>("");

	useEffect(() => {
		const showAddLineItemPanelForPageId = processedEstimatesStore.showAddLineItemPanelForPageId;
		const page = processedEstimatesStore.allCurrentViewPages.find(
			(page) => EngineUtils.pageDataFromPageInfo(page).pageId === showAddLineItemPanelForPageId,
		);
		if (page?.page.mergeWith) {
			setMergedPageId(page.page.mergeWith);
		} else {
			setMergedPageId("");
		}
	}, [processedEstimatesStore.showAddLineItemPanelForPageId]);

	return (
		<div className="self-stretch p-6 justify-end items-center inline-flex">
			<div
				className="px-4 py-2.5 bg-[#eff8ff] rounded-lg border border-[#eff8ff] justify-center items-center gap-2 flex btn"
				onClick={() => (processedEstimatesStore.showAddLineItemPanelForPageId = pageId)}
			>
				<div className="justify-start items-center gap-2 flex ">
					<img src="/assets/ui/blue-plus.svg" className="w-5 h-5 relative" />
					<div className="text-[#156fee] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">Add line</div>
				</div>
			</div>
			{(processedEstimatesStore.showAddLineItemPanelForPageId === pageId || mergedPageId === pageId) && (
				<TopMostPortal>
					<LineEditingDialog
						key={processedEstimatesStore.uniqueEditId}
						pageId={pageId}
						roomName={roomName}
						tuplesPageID={processedEstimatesStore.showAddLineItemPanelForPageId}
					/>
				</TopMostPortal>
			)}
		</div>
	);
});

export default EstimateTableFooter;
